import React from "react";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import _ from 'lodash';
import moment from 'moment';

export default class ComponentToPrint extends React.Component {
    calculateDuration(startedAt, completedTime) {
        if (!startedAt || !completedTime || startedAt === '-' || completedTime === '-') {
            return { duration: '-', hours: 0 };
        }

        const start = moment(startedAt);
        const end = moment(completedTime);
        const durationMs = end.diff(start);
        const hours = durationMs / (1000 * 60 * 60);

        return { hours: hours };
    }

    isGeneralTaskStartAfter10AM(jobTypeName, startedAt) {
        if (jobTypeName !== 'General' || !startedAt || startedAt === '-') {
            return false;
        }

        const startTime = moment(startedAt);
        const tenAM = moment(startedAt).set({ hour: 10, minute: 0, second: 0 });

        return startTime.isAfter(tenAM);
    }

    render() {
        const searchData = this.props.searchData;
        const data = this.props.data;
        const flattenedData = this.props.flattenedData;
        const usersList = this.props.usersList;

        const displayGroups = [];
        const processedJobTypes = new Set();

        flattenedData.forEach(row => {
            const jobTypeKey = row.jobTypeGroup;
            if (!processedJobTypes.has(jobTypeKey)) {
                const jobTypeRows = flattenedData.filter(r => r.jobTypeGroup === jobTypeKey);
                displayGroups.push({
                    jobTypeName: jobTypeKey,
                    rows: jobTypeRows,
                    rowSpan: jobTypeRows.length
                });
                processedJobTypes.add(jobTypeKey);
            }
        });

        return (
            <div>
                <style>
                    {`
                        @media print {
                            table {
                                border-collapse: collapse !important;
                                width: 100% !important;
                            }
                            th, td {
                                border: 1px solid #000 !important;
                                padding: 8px !important;
                                -webkit-print-color-adjust: exact !important;
                                print-color-adjust: exact !important;
                            }
                            th {
                                background-color: #f2f2f2 !important;
                            }
                            .row {
                                page-break-after: avoid !important;
                                page-break-inside: avoid !important;
                            }
                            h3 {
                                page-break-after: avoid !important;
                            }
                            .chip-container {
                                margin-bottom: 15px !important;
                                page-break-inside: avoid !important;
                                page-break-after: avoid !important;
                            }
                            .chip {
                                display: inline-block !important;
                                padding: 6px 12px !important;
                                margin: 4px !important;
                                border: 1px solid #32cd32 !important;
                                border-radius: 16px !important;
                                color: #32cd32 !important;
                                font-weight: bold !important;
                                font-size: 12px !important;
                                background-color: white !important;
                                -webkit-print-color-adjust: exact !important;
                                print-color-adjust: exact !important;
                            }
                            .legend-container {
                                margin-bottom: 10px !important;
                                padding: 8px 12px !important;
                                background-color: #f8f9fa !important;
                                border: 1px solid #e0e0e0 !important;
                                border-radius: 4px !important;
                                display: flex !important;
                                align-items: center !important;
                                gap: 16px !important;
                                -webkit-print-color-adjust: exact !important;
                                print-color-adjust: exact !important;
                                page-break-after: avoid !important;
                                page-break-inside: avoid !important;
                            }
                            .legend-box {
                                width: 20px !important;
                                height: 20px !important;
                                border: 1px solid #000 !important;
                                display: inline-block !important;
                                margin-right: 6px !important;
                                -webkit-print-color-adjust: exact !important;
                                print-color-adjust: exact !important;
                            }
                            .yellow-box {
                                background-color: #fff9c4 !important;
                            }
                            .red-box {
                                background-color: #ffe5e5 !important;
                            }
                            .highlight-yellow {
                                background-color: #fff9c4 !important;
                            }
                            .highlight-red {
                                background-color: #ffe5e5 !important;
                            }
                            .job-type-cell {
                                background-color: #f5f5f5 !important;
                                font-weight: bold !important;
                            }
                        }
                    `}
                </style>

                <h3><center><u>Muster Chit Report</u></center></h3>

                <div className="row pl-2 pb-4 pt-4">
                    <div className="col"><b>Group: </b> {searchData.group}</div>
                    <div className="col"><b>Operation Entity: </b> {searchData.estate}</div>
                    <div className="col"><b>Collection Point: </b> {searchData.division === undefined ? "All Collection Points" : searchData.division}</div>
                    <div className="col"><b>Date: </b> {searchData.date}</div>
                    <div className="col"><b>User: </b> {usersList}</div>
                    <div className="col"><b>Date/Time: </b> {new Date().toLocaleString()}</div>
                </div>

                {/* Task-Wise Job Type Count */}
                <div style={{ marginBottom: '20px', pageBreakInside: 'avoid' }}>
                    <h6 style={{ marginBottom: '10px', fontWeight: 'bold' }}>Task-Wise Job Type Count</h6>
                    <div className="chip-container">
                        {Object.entries(_.groupBy(data, "taskName")).map(([taskName, taskRows]) => {
                            const jobTypeCounts = _.groupBy(taskRows, "jobTypeName");
                            const jobTypeCountsText = Object.entries(jobTypeCounts)
                                .sort(([jobTypeA], [jobTypeB]) => {
                                    const order = { 'General': 1, 'Cash': 2, 'OT': 3, 'PLK': 99 };
                                    return (order[jobTypeA] || 999) - (order[jobTypeB] || 999);
                                })
                                .map(([jobType, rows]) => `${jobType} - ${rows.length}`)
                                .join(' / ');

                            return (
                                <span key={taskName} className="chip">
                                    {taskName} : {jobTypeCountsText}
                                </span>
                            );
                        })}
                    </div>
                </div>

                {/* Legend */}
                <div className="legend-container" style={{ marginBottom: '15px' }}>
                    <span style={{ fontWeight: '600', fontSize: '12px' }}>Legend:</span>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <span className="legend-box yellow-box"></span>
                        <span style={{ fontSize: '11px' }}>Duration &lt; 4 hours</span>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <span className="legend-box red-box"></span>
                        <span style={{ fontSize: '11px' }}>General Tasks Start After 10 a.m.</span>
                    </div>
                </div>

                {/* Table */}
                <TableContainer>
                    <Table style={{ width: '100%', borderCollapse: 'collapse' }}>
                        <TableHead>
                            <TableRow>
                                <TableCell align="center" style={{ fontWeight: "bold", border: '1px solid #000' }}>Job Type</TableCell>
                                <TableCell align="center" style={{ fontWeight: "bold", border: '1px solid #000' }}>Registration Number</TableCell>
                                <TableCell align="center" style={{ fontWeight: "bold", border: '1px solid #000' }}>Employee Name</TableCell>
                                <TableCell align="center" style={{ fontWeight: "bold", border: '1px solid #000' }}>Task Name</TableCell>
                                <TableCell align="center" style={{ fontWeight: "bold", border: '1px solid #000' }}>Field No.</TableCell>
                                <TableCell align="center" style={{ fontWeight: "bold", border: '1px solid #000' }}>Sub Field No.</TableCell>
                                <TableCell align="center" style={{ fontWeight: "bold", border: '1px solid #000' }}>Started (Date/Time)</TableCell>
                                <TableCell align="center" style={{ fontWeight: "bold", border: '1px solid #000' }}>Completed (Date/Time)</TableCell>
                                <TableCell align="center" style={{ fontWeight: "bold", border: '1px solid #000' }}>Duration (Hours)</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {displayGroups.map((jobTypeGroup, groupIdx) => (
                                <React.Fragment key={groupIdx}>
                                    {jobTypeGroup.rows.map((row, rowIdx) => {
                                        const isRedRow = this.isGeneralTaskStartAfter10AM(row.jobTypeGroup, row.startedAt);
                                        const isDurationYellow = row.jobTypeGroup === 'General' &&
                                            row.durationHours >= 0 &&
                                            row.durationHours < 4 &&
                                            row.compliation === 100 &&
                                            row.taskName?.toLowerCase() !== 'xpr';

                                        return (
                                            <TableRow
                                                key={`${groupIdx}-${rowIdx}`}
                                                style={{ backgroundColor: isRedRow ? '#ffe5e5' : 'transparent' }}
                                                className={isRedRow ? 'highlight-red' : ''}
                                            >
                                                {rowIdx === 0 && (
                                                    <TableCell
                                                        component="th"
                                                        scope="row"
                                                        align="center"
                                                        rowSpan={jobTypeGroup.rowSpan}
                                                        className="job-type-cell"
                                                        style={{
                                                            fontWeight: "bold",
                                                            backgroundColor: "#f5f5f5",
                                                            verticalAlign: "middle",
                                                            border: '1px solid #000'
                                                        }}
                                                    >
                                                        {jobTypeGroup.jobTypeName}
                                                    </TableCell>
                                                )}
                                                <TableCell align="left" style={{ border: '1px solid #000' }}>{row.employeeID}</TableCell>
                                                <TableCell align="left" style={{ border: '1px solid #000' }}>{row.employeeName}</TableCell>
                                                <TableCell align="left" style={{ border: '1px solid #000' }}>{row.taskName}</TableCell>
                                                <TableCell align="left" style={{ border: '1px solid #000' }}>{row.fieldName}</TableCell>
                                                <TableCell align="left" style={{ border: '1px solid #000' }}>{row.subFieldName}</TableCell>
                                                <TableCell align="center" style={{ border: '1px solid #000' }}>
                                                    {row.startedAt ? row.startedAt.replace("T", " ") : ""}
                                                </TableCell>
                                                <TableCell align="center" style={{ border: '1px solid #000' }}>
                                                    {row.completedTime ? row.completedTime.replace("T", " ") : ""}
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    className={isDurationYellow ? 'highlight-yellow' : ''}
                                                    style={{
                                                        backgroundColor: isDurationYellow ? '#fff9c4' : 'transparent',
                                                        fontWeight: isDurationYellow ? 'bold' : 'normal',
                                                        border: '1px solid #000'
                                                    }}
                                                >
                                                    {row.durationFormatted || '-'}
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })}
                                </React.Fragment>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
        );
    }
}